export enum TipoBlobStorage {
    firmaoperador,
    firmaconductor,
    files
}